import { Helmet } from 'react-helmet';

import {
  AddressBook,
  AffirmBanner,
  AffirmCartOptionText,
  AffirmEstimateCTA,
  AppProvider,
  ArticleEmbed,
  ArticleGridEmbed,
  AutoOfferModalButton,
  BrandCalloutEmbed,
  BrowserInfoHiddenFields,
  BulkSaleModalButton,
  BumpBid,
  BumpDisplay,
  ListingRowBumpButton,
  CSPMiniGridEmbed,
  CalloutEmbed,
  CartItemActions,
  CategoryCalloutEmbed,
  CategoryFlyoutHeader,
  CategoryNestedNav,
  CheckoutAddressBook,
  CombineAndSaveRow,
  ComparisonShoppingPageCardManager,
  CreateOfferButton,
  EmailSignUpEmbed,
  EuOdrDetailsContainer,
  EuOdrDetailsDashboardContainer,
  FeedbackContainer,
  FreeShippingProgressBarContainer,
  FollowButtonContainer,
  GiftCardSendDatePicker,
  GiftCardCreditCards,
  HandpickedCalloutEmbed,
  HomepageCuratedSetRow,
  ItemRelatedBuyingGuide,
  Spinner,
  setRoutes,
  LightboxImage,
  ListingRow,
  ListingSidebarCSP,
  LocalePickerButton,
  MessageForm,
  MessageInput,
  MobileDetection,
  Modal,
  PacklinkLinkAccountButton,
  PacklinkShippingLabelButton,
  PayoutMethodFormFields,
  Photos,
  PromoCodeRedemptionForm,
  RecentlyViewedListings,
  RefundRequestFormFields,
  RegionalListings,
  SearchHeader,
  SellCSPPreview,
  ShipOrderHeader,
  ShippingRatesEditor,
  SimilarCSPsRow,
  SiteFooterContainer,
  SmartRecruiterJobs,
  SiteSearch,
  StarRating,
  StarRatingSelector,
  StatementBillingMethodContainer,
  Subscriptions,
  TaxPolicyUS,
  UpdateOfferButton,
  VideoEmbed,
  WatchedListings,
  alt,
  buildReverbRouter,
  buildRootRoutes,
} from '@reverbdotcom/discovery-ui';

import {
  TooltipPanel,
} from '@reverbdotcom/commons';

import Routes from './shared/routes';
import trackPageView from './track_page_view';

window.Reverb = window.Reverb || {};
window.ReverbAppProviderV2 = AppProvider;
window.Reverb.AffirmBanner = AffirmBanner;
window.Reverb.AffirmCartOptionText = AffirmCartOptionText;
window.Reverb.ArticleEmbed = ArticleEmbed;
window.Reverb.ArticleGridEmbed = ArticleGridEmbed;
window.Reverb.AutoOfferModalButton = AutoOfferModalButton;
window.Reverb.BrandCalloutEmbed = BrandCalloutEmbed;
window.Reverb.BrowserInfoHiddenFields = BrowserInfoHiddenFields;
window.Reverb.BulkSaleModalButton = BulkSaleModalButton;

// bump components
window.Reverb.BumpDisplay = BumpDisplay;
window.Reverb.BumpBid = BumpBid;
window.Reverb.ListingRowBumpButton = ListingRowBumpButton;

window.Reverb.CalloutEmbed = CalloutEmbed;
// this component is still embedded in articles, leaving it defined but as a no-op
window.Reverb.LPAlbumRowEmbed = () => { return null; };
window.Reverb.CategoryCalloutEmbed = CategoryCalloutEmbed;
window.Reverb.CategoryFlyoutHeader = CategoryFlyoutHeader;
window.Reverb.CategoryNestedNav = CategoryNestedNav;
window.Reverb.CombineAndSaveRow = CombineAndSaveRow;
window.Reverb.ComparisonShoppingPageCardManager = ComparisonShoppingPageCardManager;
window.Reverb.CreateOfferButton = CreateOfferButton;
window.Reverb.CSPMiniGridEmbed = CSPMiniGridEmbed;
window.Reverb.Spinner = Spinner;
window.Reverb.ListingSidebarCSP = ListingSidebarCSP;
window.Reverb.FeedbackContainer = FeedbackContainer;
window.Reverb.FollowButtonContainer = FollowButtonContainer;
window.Reverb.FreeShippingProgressBarContainer = FreeShippingProgressBarContainer;
window.Reverb.HandpickedCalloutEmbed = HandpickedCalloutEmbed;
window.Reverb.HomepageCuratedSetRow = HomepageCuratedSetRow;
window.Reverb.LightboxImage = LightboxImage;
window.Reverb.ListingRow = ListingRow;
window.Reverb.LocalePickerButton = LocalePickerButton;
window.Reverb.Modal = Modal;
window.Reverb.PacklinkLinkAccountButton = PacklinkLinkAccountButton;
window.Reverb.PacklinkShippingLabelButton = PacklinkShippingLabelButton;
window.Reverb.PayoutMethodFormFields = PayoutMethodFormFields;
window.Reverb.RecentlyViewedListings = RecentlyViewedListings;
window.Reverb.RegionalListings = RegionalListings;
window.Reverb.ShippingRatesEditor = ShippingRatesEditor;
window.Reverb.SimilarCSPsRow = SimilarCSPsRow;
window.Reverb.SearchBarV2 = SiteSearch;
window.Reverb.SearchHeader = SearchHeader;
window.Reverb.SiteFooter = SiteFooterContainer;
window.Reverb.AffirmEstimateCTA = AffirmEstimateCTA;
window.Reverb.SmartRecruiterJobs = SmartRecruiterJobs;
window.Reverb.StarRating = StarRating;
window.Reverb.StarRatingSelector = StarRatingSelector;
window.Reverb.StatementBillingMethodContainer = StatementBillingMethodContainer;
window.Reverb.Subscriptions = Subscriptions;
window.Reverb.TaxPolicyUS = TaxPolicyUS;
window.Reverb.UpdateOfferButton = UpdateOfferButton;
window.Reverb.VideoEmbed = VideoEmbed;
window.Reverb.WatchedListings = WatchedListings;
window.Reverb.SellCSPPreview = SellCSPPreview;
window.Reverb.AddressBook = AddressBook;
window.Reverb.CheckoutAddressBook = CheckoutAddressBook;
window.Reverb.EmailSignUp = EmailSignUpEmbed;
window.Reverb.EuOdrDetailsContainer = EuOdrDetailsContainer;
window.Reverb.EuOdrDetailsDashboardContainer = EuOdrDetailsDashboardContainer;
window.Reverb.GiftCardSendDatePicker = GiftCardSendDatePicker;
window.Reverb.GiftCardCreditCards = GiftCardCreditCards;
window.Reverb.ShipOrderHeader = ShipOrderHeader;
window.Reverb.Photos = Photos;
window.Reverb.ItemRelatedBuyingGuide = ItemRelatedBuyingGuide;
window.Reverb.RefundRequests = {
  FormFields: RefundRequestFormFields,
};
window.Reverb.CartItemActions = CartItemActions;

window.Reverb.CommonAlt = alt;
window.RREHelmet = Helmet;

window.Reverb.Routes = buildRootRoutes(Routes); // exposed for server side rendering
setRoutes(window.Reverb.Routes);


window.Reverb.noRouterContext = true;
window.Reverb.Router = buildReverbRouter(Routes, {
  onUpdate: () => {
    trackPageView(window.location);
    window.Reverb.noRouterContext = false;
  },
});

window.Reverb.MobileDetection = MobileDetection;

window.Reverb.Conversations = window.Reverb.Conversations || {};
window.Reverb.Conversations.BodyInput = MessageInput;
window.Reverb.Conversations.Form = MessageForm;
window.Reverb.PromoCodeRedemptionForm = PromoCodeRedemptionForm;
window.Reverb.TooltipPanel = TooltipPanel;



// WEBPACK FOOTER //
// ./javascripts/components/discovery.js